import React from 'react'
import styled from 'styled-components'
import extend from 'smart-extend'
import Point, {PlaceholderPoint} from './Point'
import contactPoints from '../contact-points'

Grid = ({card, points=[], color, demo, interactive, min, handleClick})->
	remainingPoints = min - points.length
	placeholderPoints = [1..Math.max(2, remainingPoints)]
	
	<Wrapper>
		{points.map (point, i)->
			{data, config} = preparePointData(point, card)
			<Point
				originalPoint={point}
				point={data}
				config={config}
				key={i}
				demo={demo}
				color={color}
				card={card}
				handleClick={handleClick}
			/>
		}
		{if interactive and min
			placeholderPoints.map (i)->
				return if i < 1
				<PlaceholderPoint
					key={i}
					color={color}
					alwaysVisible={i is 1}
					handleClick={handleClick}
				/>
		}
	</Wrapper>

preparePointData = (point, card)->
	config = contactPoints.find(type:point.type)
	update = {}

	if config?.displayValue
		update.value = config.displayValue(point.value, card)
	
	if point.type is 'website' and point.href?.includes('10000cards')
		ref = "ref=#{card._id}"
		if point.href.includes('?')
			update.href = "#{point.href}&#{ref}"
		else
			update.href = "#{point.href}?#{ref}"
	
	return {config, data:{point..., update...}}
	

Wrapper = styled.div"""
	display: flex
	flex-wrap: wrap
	width: 100%
	background-color: #e6e6e6
"""

export default Grid